<template>
	<div class="rows">
		<ValidationProvider
			ref="provider"
			:vid="`${computedName}-${generatedId}`"
			:name="options.label"
			:rules="computedRules"
			v-slot="{ errors, classes }"
			slim
		>
			<div :class="[options.wrapperClass, { disabled: isDisabled, 'mb-8px': errors[0] === undefined }]">
				<label class="input-label d-table w-100 text-center" v-if="options.sidebar">{{ options.label }}</label>
				<span
					:class="[
						options.tooltip ? 'input-tooltip' : '',
						options.unit ? 'input-unit' : '',
						'w-100',
						options.className,
						classes,
					]"
				>
					<input
						:placeholder="options.label"
						type="text"
						:name="computedName"
						:class="options.className"
						:id="generatedId"
						:value="formatValue(getData())"
						@input="setData(computedValue($event.target.value))"
						v-mask="options.mask"
						:inputmode="options.inputmode"
						:disabled="isDisabled"
						data-hj-allow
					/>
					<span v-if="options.unit" class="unit">{{ options.unit }}</span>
					<span v-if="options.tooltip" v-tooltip="options.tooltipText" class="info"></span>
				</span>
				<span
					:class="[
						'error_message error_message--broke',
						options.className,
						{ 'mb-8px': type === 'contracting' },
					]"
					v-if="errors[0]"
				>
					{{ errors[0] }}
				</span>
			</div>
		</ValidationProvider>
	</div>
</template>

<script>
import shared from '@/mixins/shared';
import _ from 'lodash';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	async mounted() {
		if (this.getBanks === null) {
			await this.fetchBanks();
		}
	},
	mixins: [shared],
	computed: {
		...mapGetters('contracting', ['getBanks']),
		isDisabled() {
			if (_.has(this.options, 'disabled')) {
				return this.$store.state[this.options.disabled];
			}

			return this.disabled;
		},
		computedRules() {
			return {
				...this.options.rules,
				bank_search: { banks: this.getBanks },
			};
		},
	},
	methods: {
		...mapActions('contracting', ['fetchBanks']),
	},
};
</script>
